import type { ProgramUserRsvp } from 'models';
import { useCallback } from 'react';
import { CheckCircleFillIcon, CloseCircleFillIcon, TimeFilledIcon } from 'ui';

export const useGetInviteesBadgeIcon = () =>
  useCallback(({ rsvp }: { rsvp: ProgramUserRsvp }) => {
    switch (rsvp) {
      case 'going':
        return <CheckCircleFillIcon backgroundColor="white" shape="circle" size="extra-extra-small" type="success" />;
      case 'not_going':
        return <CloseCircleFillIcon backgroundColor="white" shape="circle" size="extra-extra-small" type="error" />;
      case 'pending':
        return <TimeFilledIcon backgroundColor="white" shape="circle" size="extra-extra-small" type="secondary" />;
    }
  }, []);
